<template>
	<div class="detail">
		<PageHeaderLayout :isBack="true">
			<div class="main" v-if="loading">
				<div class="text-content">
					<el-input
						type="textarea"
						:rows="2"
						placeholder="请输入内容"
						v-model="detail.deliver_content"
						autosize
						:readonly="query.type == 'examine'"
					>
					</el-input>
				</div>

				<div class="img-content">
					<UploadImg ref="uploadImgRef" :disabled="query.type == 'examine'" />
				</div>
				<div
					style="margin-top: 20px"
					v-if="query.type == 'examine' && detail.deliver_status == 1"
				>
					<span class="dialog-footer">
						<el-button @click="jujue" type="danger">驳回</el-button>
						<el-button @click="tonguo" class="tonguo" type="primary"
							>通过</el-button
						>
					</span>
				</div>
				<div style="margin-top: 20px" v-if="query.type == 'edit'">
					<span class="dialog-footer">
						<el-button @click="save" class="tonguo" type="primary"
							>保存</el-button
						>
						<div></div>
					</span>
				</div>
			</div>

			<el-dialog
				title="提示"
				:visible.sync="examinedialogVisible"
				width="50%"
				@close="examinedialogVisible = false"
			>
				<div style="margin-top: 30px">
					<el-input
						type="textarea"
						placeholder="请输入拒绝原因"
						v-model="detail.deliver_message"
						maxlength="100"
						show-word-limit
						:rows="5"
					></el-input>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="examinedialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="examine">确 定</el-button>
				</span>
			</el-dialog>
		</PageHeaderLayout>
	</div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import UploadImg from "@/components/uploadImg/index.vue";
export default {
	components: {
		DatePicker,
		PageHeaderLayout,
		UploadImg,
	},
	data() {
		return {
			query: {},
			loading: false,
			detail: {
				deliver_content: "",
				deliver_images: [],
				deliver_status: "", //交付状态2交付通过3交付未通过,
				deliver_message: "", //未通过原因
			},
			sysData: {
				deliver_status: "",
			},
			examinedialogVisible: false,
		};
	},
	created() {
		this.query = this.$route.query;
		this.getInfo();
	},

	methods: {
		async getInfo() {
			this.loading = false;
			console.log("getInfo");
			let data = await this.$api.post_task_privatejoinInfo({
				id: this.query.id,
			});
			this.loading = true;
			console.log(data);
			this.detail = data;
			this.detail.deliver_images = data?.deliver_images;
			setTimeout(() => {
				this.$refs.uploadImgRef.setImagesList(this.detail.deliver_images);
			}, 100);
		},
		async examine() {
			let params = {
				id:this.query.id,
				deliver_status: this.sysData.deliver_status,
				deliver_message: this.detail.deliver_message,
			};
			await this.$api.post_task_privatejoinAudit(params);
			this.examinedialogVisible = false;
			this.$message.success("审核成功");
			this.getInfo();
		},
		jujue() {
			this.examinedialogVisible = true;
			this.sysData.deliver_status = 3;
		},
		tonguo() {
			this.sysData.deliver_status = 2;
			this.examine();
		},
		async save() {
			let imgs = this.$refs.uploadImgRef.getImagesList();
			console.log(imgs, "imgs");
			let params = {
				id: this.query.id,
				deliver_content: this.detail.deliver_content,
				deliver_images: imgs.join(","),
			};
			if (params.deliver_images.length === 0) {
				this.$message.warning("请上传图片");
				return;
			}
			if (params.deliver_content.length === 0) {
				this.$message.warning("请输入内容");
				return;
			}

			await this.$api.post_task_privatejoinUpdate(params);
			this.$message.success("保存成功");
			this.getInfo();
		},
	},
};
</script>

<style scoped lang="scss">
.detail {
	background-color: #fff;
	border-radius: 24px;
	padding: 24px;
	height: 100%;
	.text-content {
		width: 500px;
		min-height: 120px;
		background-color: #f2f3f7;
		border-radius: 24px;
		padding: 24px;
		::v-deep .el-textarea__inner {
			height: 100% !important;
			background-color: #f2f3f7;
			border: none !important;
			resize: none !important;
			padding: 0 !important;
		}
	}
	.img-content {
		margin-top: 24px;
		.item-img {
			margin-bottom: 24px;
		}
		.img-icon {
			width: 500px;
			height: auto;
		}
	}
	.tonguo {
		margin-left: 50px;
	}
}
</style>
